import React from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Zoom,
} from "@mui/material";
import {
  Instagram,
  LinkedIn,
  Language,
  Phone,
  Email,
  Textsms,
  Add,
} from "@mui/icons-material";
import { QRCodeSVG } from "qrcode.react";

const DigitalContactCard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fullName = "Britney Epps";
  const alias = "Nerd";
  const phoneNumber = "+17047795884";
  const email = "thenerdstar101@gmail.com";
  const contactURL = "https://nerdstar101.com/"; // Update with actual deployed URL

  const primaryColor = "#6C63FF";
  const accentColor = "#00B8D4";

  const handleAddContact = () => {
    const vCard = `
BEGIN:VCARD
VERSION:3.0
N:${fullName}
FN:${fullName}
TEL:${phoneNumber}
EMAIL:${email}
END:VCARD
    `.trim();

    const blob = new Blob([vCard], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${alias}_contact.vcf`;
    a.click();
  };

  const socialLinks = [
    {
      icon: <Instagram fontSize="large" />,
      label: "Instagram",
      url: "https://instagram.com/nerdstar_101",
    },
    {
      icon: <LinkedIn fontSize="large" />,
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/britney-epps-43255946/",
    },
    {
      icon: <Language fontSize="large" />,
      label: "Website",
      url: "https://nerdstar101.com/",
    },
  ];

  const extraLinks = [
    { label: "Shop BR", url: "https://showbothrows.com" },
    {
      label: "The Ether Detroit",
      url: "https://instagram.com/theetherdetroit",
    },
    { label: "Subscribe to YouTube", url: "https://youtube.com/@nerdstar_101" },
    {
      label: "Setup Design Consultation",
      url: `mailto:${email}?subject=Fashion Design Consultation`,
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #f0f4ff, #ede7f6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 4,
      }}
    >
      <Zoom in>
        <Box
          sx={{
            maxWidth: 650,
            width: "100%",
            backgroundColor: "#ffffff",
            padding: 4,
            borderRadius: 4,
            boxShadow: 6,
            textAlign: "center",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <Avatar
            src="/images/my-headshot.JPG"
            alt={fullName}
            sx={{ width: 120, height: 120, margin: "auto", mb: 2 }}
            loading="lazy"
          />
          <Typography variant="h5" fontWeight="bold" color={primaryColor}>
            {fullName}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            @{alias}
          </Typography>

          <Box
            mt={2}
            mb={3}
            px={2}
            py={1}
            sx={{
              backgroundColor: "#e8eaf6",
              borderRadius: 2,
              fontStyle: "italic",
              fontSize: "0.95rem",
              lineHeight: 1.6,
              color: "#444",
            }}
          >
            “Fashion is more than cloth sewn together; it's the first chapter of
            your story, written in fabric and worn with purpose. I create so
            everyone can see themselves when they look in the mirror.”
          </Box>

          {/* Socials */}
          <Grid container spacing={2} justifyContent="center" mt={2}>
            {socialLinks.map((item, idx) => (
              <Grid item key={idx} xs={3} sm="auto">
                <Box>
                  <IconButton
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: primaryColor,
                      "&:hover": {
                        transform: "scale(1.2)",
                        transition: "0.3s",
                      },
                    }}
                  >
                    {item.icon}
                  </IconButton>
                  <Typography variant="caption">{item.label}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Contact Buttons */}
          <Grid container spacing={2} justifyContent="center" mt={3}>
            {[
              {
                label: "Call",
                icon: <Phone />,
                link: `tel:${phoneNumber}`,
              },
              {
                label: "Text",
                icon: <Textsms />,
                link: `sms:${phoneNumber}`,
              },
              {
                label: "Email",
                icon: <Email />,
                link: `mailto:${email}`,
              },
              {
                label: "Add Contact",
                icon: <Add />,
                onClick: handleAddContact,
              },
            ].map((btn, idx) => (
              <Grid item xs={12} sm="auto" key={idx}>
                <Button
                  variant="contained"
                  startIcon={btn.icon}
                  fullWidth={isMobile}
                  href={btn.link || undefined}
                  onClick={btn.onClick || undefined}
                  sx={{
                    backgroundColor: primaryColor,
                    "&:hover": {
                      backgroundColor: accentColor,
                    },
                  }}
                >
                  {btn.label}
                </Button>
              </Grid>
            ))}
          </Grid>

          {/* Explore More */}
          <Box mt={5}>
            <Typography variant="h6" fontWeight="medium" gutterBottom>
              Explore More
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {extraLinks.map((link, idx) => (
                <Grid item key={idx} xs={12} sm="auto">
                  <Button
                    variant="outlined"
                    href={link.url}
                    target="_blank"
                    sx={{
                      textTransform: "none",
                      borderRadius: "30px",
                      borderColor: primaryColor,
                      color: primaryColor,
                      "&:hover": {
                        backgroundColor: "#f3f5ff",
                      },
                    }}
                  >
                    {link.label}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* QR Code */}
          <Box mt={5}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Tap or scan this QR code to return here anytime.
            </Typography>
            <QRCodeSVG value={contactURL} size={128} fgColor={primaryColor} />
          </Box>
        </Box>
      </Zoom>
    </Box>
  );
};

export default DigitalContactCard;
